import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Papa from 'papaparse';
import Home from './pages/Home'
import GetInvolved from './pages/GetInvolved';
import ExecutiveBoard from './pages/ExecutiveBoard';
import Gallery from './pages/Gallery'

function App() {
    const [pictures, setPictures] = useState([]);
	const [members, setMembers] = useState([]);
	const [events, setEvents] = useState([]);

    const SHEET_URL_GALLERY =
        'https://docs.google.com/spreadsheets/d/e/2PACX-1vQhKO9FeDpMUXV4pMzXAtGF4Vo-d7U4NBG_QlCEzgv-Y6DcUs7Yyt6lX51XAfXq4_iVlw_MjxSTTNsR/pub?output=csv';
	const SHEET_URL_MEMBERS = 
		'https://docs.google.com/spreadsheets/d/e/2PACX-1vQR6m7_Lil3mIYfFZ49V8BlkjDRuah8zE4UtsSZBTGvhLG2jlanBWCM4UG_JqOc_rOXqgeuuues5aDj/pub?output=csv';
	const SHEET_URL_EVENTS = 
		'https://docs.google.com/spreadsheets/d/e/2PACX-1vQklvcAwnUwA8FAjLNl2STQrLNS5C1TchRu-lFaTU1d_0HuMEtrmaVulKhEUK9_MRyx5w9XLsZOs3yM/pub?output=csv';

    useEffect(() => {
        fetch(SHEET_URL_GALLERY)
            .then((res) => res.text())
            .then((csvText) => {
                Papa.parse(csvText, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        const rows = (results.data || []).filter(
                            (r) => (r.Link && r.Link.trim() !== '') || (r.Caption && r.Caption.trim() !== '')
                        )
                        .reverse();
                        setPictures(rows);
                    },
                });
            })
            .catch((err) => {
                console.error('Failed to fetch/parse sheet:', err);
            });

		fetch(SHEET_URL_MEMBERS)
			.then((res) => res.text())
			.then((csvText) => {
				Papa.parse(csvText, {
					header: true,
					skipEmptyLines: true,
					complete: (results) => {
						setMembers(results.data);
					},
				});
			});
		
		fetch(SHEET_URL_EVENTS)
			.then((res) => res.text())
			.then((csvText) => {
			Papa.parse(csvText, {
				header: true,
				skipEmptyLines: true,
				complete: (results) => {
				setEvents(results.data);
				},
			});
			});
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="*" element={<Home events={events} />} />
                <Route path="/" element={<Home events={events} />} />
                <Route path="/get-involved" element={<GetInvolved events={events} />} />
                <Route path="/executive-board" element={<ExecutiveBoard members={members} />} />
                <Route path="/Gallery" element={<Gallery pictures={pictures} />} />
            </Routes>
        </Router>
    );
}

export default App;